import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  Chip,
  Checkbox,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CloseIcon from "@material-ui/icons/Close";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import ReplayIcon from "@material-ui/icons/Replay";
import CloseModalButton from "Admin/Common/CloseModalButton";
import GeneralSebiActivities from "Admin/Sebi/GeneralSebiActivities";
import instance from "api/globalaxios";
import { useSnackbar } from "contexts/SnackbarContext";
import FormError from "../Components/FormError";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import FormattedMessage from "features/common/TranslatedMessage";
import { DropzoneDialog } from "material-ui-dropzone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import { getRealhost } from "slices/disputeSlice";
import { isArb, isMSME, isSebi, isTiac } from "Routes/Routes";
import {
  approvedDispute,
  CloseDisputeAtLevelTwo,
  downloadLegalDoc,
  gethost,
  tiacdoc,
  updateDispute,
} from "slices/disputeSlice";
// import { formatDate } from "utils";
import CaseDisplayProfileList from "./CaseDisplayProfileList";
import CaseManager from "./CaseManager";
import Company from "./Company";
import Complainant from "./Complainant";
import GRO from "./GRO";
import RespondentLawyer from "./Respondentlawyer";
import SRB from "./SRB";
import Summary from "./Summary";
import Witness from "./Witness";
import CaseAssignInput from "Admin/Sebi/CaseAssignInput";
import { formatPartyName, isAllowedAmountInput, isCaseReopened, parseCaseNumber, safeDateFormat } from "../utils";
import useBACPermissions from "../hooks/usePermissions";
import { ADMIN_TABS, navigateToAdminTab } from "./adminTabNavigation";
import ReopenedChip from "../Components/ReopenedChip";
import GeneralActivitiesACCB from "../GeneralActivitiesACCB";
import MandateClock from "../Components/MandateClock";
import { getBacClosureReasons, reopenDispute } from "../service";
import DatePickerACCB from "../Components/DatePickerACCB";
import { formatApiDate } from "../Components/adjournmentUtils";

const useStyles = makeStyles((theme) => ({
  backbtn: {
    fontSize: "18px",
    lineHeight: "21px",
    letterSpacing: "0.4px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "15px",
    },
  },
  blackheading: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "23px",
    letterSpacing: "0.4px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "15px",
    },
  },
  bigbtn: {
    fontWeight: "bold",
    fontSize: "1rem",
    lineHeight: "36px",
    letterSpacing: "0.4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "15px",
    },
  },
  closedbtn: {
    background: "#E0E0E0",
    color: "white",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "36px",
    letterSpacing: "0.4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "15px",
    },
  },
  blueheading: {
    fontWeight: "bold",
    fontSize: "1rem",
    // lineHeight: "36px",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  awardpaper: {
    margin: "3rem auto",
    height: "80%",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "scroll",
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      height: "80%",
      padding: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      height: "80%",
      padding: "0.5rem",
    },
  },
  dropzonePreviewItem: {
    maxWidth: "100%",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  },
  activityText: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    color: TEXT.secondary,
  },
  awardModalPaper: {
    margin: "3rem auto",
    width: "100%",
    maxWidth: "720px",
    maxHeight: "85vh",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 4),
    textAlign: "center",
    outline: "none",
    borderRadius: "8px",
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "92%",
      padding: theme.spacing(2, 2, 3),
    },
  },
  awardModalTitle: {
    // CloseModalButton floats right, so clear it to get a full-width line box
    // and a genuinely centred title rather than one nudged off-centre.
    clear: "both",
    fontSize: "1.25rem",
    fontWeight: 600,
    color: TEXT.primary,
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.05rem",
    },
  },
  closeCaseHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.9rem",
    padding: "1.5rem 1.5rem 0",
  },
  closeCaseIcon: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    backgroundColor: "#FDECEA",
    color: TEXT.error,
  },
  closeCaseTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    lineHeight: 1.3,
    color: TEXT.strong,
  },
  closeCaseSubtitle: {
    marginTop: "0.3rem",
    fontSize: "0.9rem",
    lineHeight: 1.5,
    color: TEXT.secondary,
  },
  closeCaseDismiss: {
    marginLeft: "auto",
    marginTop: "-0.5rem",
    marginRight: "-0.75rem",
    padding: "0.5rem",
    color: TEXT.muted,
  },
  closeCaseBody: {
    padding: "1.25rem 1.5rem 1.5rem",
  },
  closeCaseEmpty: {
    padding: "0.75rem 1rem",
    fontSize: "0.9rem",
    color: TEXT.muted,
    fontStyle: "italic",
  },
  closeCaseActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.75rem",
    padding: "1rem 1.5rem",
    borderTop: "1px solid #E5E5E5",
    backgroundColor: "#FAFAFA",
    borderRadius: "0 0 8px 8px",
    "& .MuiButton-root": {
      padding: "0.5rem 1.25rem",
      fontSize: "0.95rem",
    },
  },
  closeCaseConfirm: {
    minWidth: "120px",
  },
  reopenedOn: {
    marginTop: "6px",
    fontSize: "0.9rem",
    fontWeight: 600,
    color: TEXT.brand,
  },
  reopenCaseIcon: {
    backgroundColor: "#F4EFF6",
    color: theme.palette.primary.main,
  },
  awardTableWrap: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: "1.5rem",
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    // TableContainer defaults to overflowX: auto; the columns are all
    // percentage-based and the names wrap, so nothing needs to scroll.
    overflowX: "hidden",
    "& table": {
      width: "100%",
      maxWidth: "100%",
      height: "auto",
      margin: 0,
      marginTop: 0,
      borderCollapse: "collapse",
      // Fixed layout stops a long file name from stretching the other columns.
      tableLayout: "fixed",
      fontFamily: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
    },
    "& th, & td": {
      border: "none",
      padding: "12px 16px",
      fontSize: "0.9rem",
      color: TEXT.secondary,
      verticalAlign: "middle",
    },
    "& thead th": {
      backgroundColor: "#F5F5F7",
      color: TEXT.primary,
      fontWeight: 600,
      fontSize: "0.75rem",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      borderBottom: "1px solid #E5E5E5",
    },
    "& tbody tr + tr td": {
      borderTop: "1px solid #F0F0F0",
    },
    "& tbody tr:hover": {
      backgroundColor: "#FAFAFB",
    },
    [theme.breakpoints.down("xs")]: {
      "& th, & td": {
        padding: "10px 8px",
        fontSize: "0.8rem",
      },
      "& thead th": {
        fontSize: "0.75rem",
      },
    },
  },
  awardDocName: {
    display: "block",
    fontSize: "inherit",
    fontWeight: 500,
    color: theme.palette.primary.main,
    cursor: "pointer",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    lineHeight: 1.45,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  awardShareBtn: {
    fontSize: "0.8rem",
    fontWeight: 500,
    textTransform: "none",
    padding: "2px 6px",
    minWidth: "auto",
  },
  awardSharedChip: {
    height: "22px",
    fontSize: "0.75rem",
    fontWeight: 500,
    color: TEXT.success,
    backgroundColor: "#E7F5EC",
  },
  awardEmptyCell: {
    fontSize: "0.9rem",
    color: TEXT.muted,
    padding: "2rem 8px",
  },
  awardDropzone: {
    margin: "1.5rem auto 0",
    maxWidth: "400px",
    padding: "1.25rem",
    border: "1px dashed #C9C9CF",
    borderRadius: "8px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "border-color 120ms ease, background-color 120ms ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#FAF7FB",
    },
  },
  awardDropzoneText: {
    fontSize: "0.85rem",
    color: TEXT.muted,
    marginTop: "0.35rem",
  },
}));

function breakableFileName(name) {
  const text = String(name == null ? "" : name);
  const chunks = text.match(/[^_.\-\s]*[_.\-\s]+|[^_.\-\s]+/g) || [text];
  return chunks.map((chunk, index) => (
    <React.Fragment key={index}>
      {chunk}
      {index < chunks.length - 1 && <wbr />}
    </React.Fragment>
  ));
}

function getNewCasefiles(dispute_id) {
  return async () => {
    try {
      const response = await instance.get(
        `/tiacassigndessigncasefile/${dispute_id}`
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

// Longest "Reason for Reopening" the reopen popup accepts.
const REOPEN_REASON_MAX_LENGTH = 300;

export default function CaseDisplay({
  setOpenCase,
  isSmallScreen,
  caseId,
  mode,
  profile,
  reloadOverview,
}) {
  const history = useHistory();
  const { can } = useBACPermissions();

  // Jump to the Order Drafting tab with this case searched and its drafts
  // loaded.
  const openOrderDrafting = () => {
    navigateToAdminTab(
      history,
      ADMIN_TABS.ORDER_DRAFTING,
      parseCaseNumber(dispute?.tiac_custom_dispute_id)
    );
  };
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();

  let split_by = "vs.";

  const updateDisputeName = () => {
    dispatch(getNewCasefiles(caseId)).then((res) => {
      if (!Array.isArray(res)) return;

      const c_casefiles = res.filter((item) => item.type === "claimant");
      const r_casefiles = res.filter((item) => item.type === "respondent");

      const sortById = (a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
      c_casefiles.sort(sortById);
      r_casefiles.sort(sortById);

      const claimantText = formatPartyName(c_casefiles);
      const respondentText = formatPartyName(r_casefiles);

      let finalName = "";
      if (claimantText && respondentText) {
        finalName = `${claimantText} ${split_by} ${respondentText}`;
      } else {
        finalName = claimantText || respondentText;
      }

      dispatch(
        updateDispute({
          id: caseId,
          name: finalName,
        })
      ).then(() => {
        reloadOverview();
      });
    });
  };

  const [dispute, setDispute] = useState();
  const [isDisputeClosed, setIsDisputeClosed] = React.useState();
  const [startDate, setStartDate] = useState();
  const [approvedDate, setApprovedDate] = useState("---");
  const [summary, setSummary] = useState();
  const [complainantData, setcomplainantData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [groData, setgroData] = useState();
  const [lawyerData, setLawyerData] = useState();
  const [lawyerDataRV, setLawyerDataRV] = useState();
  const [casefiles, setCasefiles] = useState();
  const [witnessData, setwitnessData] = useState();
  const [casemanagerData, setCasemanagerData] = useState();
  const [allProfiles, setAllProfiles] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingCaseClose, setLoadingCaseClose] = useState(false);
  const [openReopen, setOpenReopen] = useState(false);
  const [loadingReopen, setLoadingReopen] = useState(false);
  const [reopenError, setReopenError] = useState("");
  const [reopenReason, setReopenReason] = useState("");
  const [reopenReasonError, setReopenReasonError] = useState("");

  // Open a case at the top of the view. This has to wait for `loading`, since
  // nothing but the spinner is mounted before then.
  const topRef = useRef(null);
  useEffect(() => {
    if (!loading && topRef.current) {
      topRef.current.scrollIntoView({ behavior: "auto", block: "start" });
    }
  }, [loading]);

  const [allAssignedPrifiles, setallAssignedPrifiles] = useState([]);

  const [ClaimantLawyerData, setClaimantLawyerData] = useState([]);
  const [RespondentLawyerData, setRespondentLawyerData] = useState([]);

  const [commonFiles, setCommonFiles] = useState([]);
  const [decisions, setdecisions] = useState([]);
  const [activities, setActivities] = useState([]);

  // ---- Final Award Extra Details ----
  const [awardParties, setAwardParties] = useState([]);
  const [awardInFavourOf, setAwardInFavourOf] = useState("");
  const [awardValue, setAwardValue] = useState("");
  const [applicableStampDuty, setApplicableStampDuty] = useState("");
  const [awardError, setAwardError] = useState("");
  const [registerError, setRegisterError] = useState("");
  const [isMultiAwardParties, setIsMultiAwardParties] = useState(false);

  // ---- BAC Closure Reasons ----
  const [closureReasons, setClosureReasons] = useState([]);
  const [selectedClosureReason, setSelectedClosureReason] = useState("");
  const [closureReasonError, setClosureReasonError] = useState("");
  const [closureReasonsLoading, setClosureReasonsLoading] = useState(false);
  // Date of Disposal captured alongside the Nature of Disposal when closing.
  const [disposalDate, setDisposalDate] = useState(null);
  const [disposalDateError, setDisposalDateError] = useState("");

  const fetchClosureReasons = async () => {
    try {
      setClosureReasonsLoading(true);
      const res = await getBacClosureReasons();
      if (res?.data?.success && Array.isArray(res?.data?.data)) {
        setClosureReasons(res.data.data);
      } else if (Array.isArray(res?.data)) {
        setClosureReasons(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch BAC closure reasons:", err);
    } finally {
      setClosureReasonsLoading(false);
    }
  };

  const refresh = () => {
    dispatch(disputeDetails()).then(() => { });
  };

  React.useEffect(() => {
    refresh();
  }, []);

  function disputeDetails() {
    return async () => {
      try {
        setLoading(true);
        const response = await instance.get(
          `/api/tiacrvdisputedetailsbyid/${caseId}/`
        );
        let response2 = await instance({
          method: "get",
          url: "/api/casefile/" + "?host=" + gethost(),
          params: {
            dispute__id: caseId,
          },
        });
        // if (isSebi || isMSME) {
        //   dispatch(getActivityByTabAndId('general',caseId)).then((res) => {
        //     setActivities(res);
        //   });
        // }
        let casefilesres = response2.data.results;
        setCasefiles(casefilesres);

        let casefile_respondent = [];
        let new_cl_lawyer = [];
        let new_rsp_lawyer = [];
        casefilesres.sort(function (a, b) {
          var nameA = a.id;
          var nameB = b.id;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        let cl_index = 0;
        let resp_index = 0;
        casefilesres.forEach((casefile) => {
          if (casefile.type == "claimant") {
            casefile_respondent.push(casefile);
            if (casefile.lawyer_rv.length == 0) {
              new_cl_lawyer.push({
                index: cl_index,
                casefile: casefile,
                lawyer: null,
              });
            }
            casefile.lawyer_rv.forEach((i) => {
              new_cl_lawyer.push({
                index: cl_index,
                casefile: casefile,
                lawyer: i,
                all: casefile.lawyer_rv,
              });
            });
            cl_index += 1;
          } else {
            casefile_respondent.push(casefile);
            if (casefile.lawyer_rv.length == 0) {
              new_rsp_lawyer.push({
                index: resp_index,
                casefile: casefile,
                lawyer: null,
              });
            }
            casefile.lawyer_rv.forEach((i) => {
              new_rsp_lawyer.push({
                index: resp_index,
                casefile: casefile,
                lawyer: i,
                all: casefile.lawyer_rv,
              });
            });
            resp_index += 1;
          }
        });
        setClaimantLawyerData(new_cl_lawyer);
        setRespondentLawyerData(new_rsp_lawyer);

        let d = response.data;
        setDispute(d.dispute_data.dispute[0]);
        setCommonFiles(
          d.dispute_data.all_docs.filter((item) => item.is_rfa_rv)
        );
        setdecisions(d.dispute_data.all_docs.filter((item) => !item.is_rfa_rv));
        setIsDisputeClosed(d.dispute_data.dispute[0].status == "closed");
        setSummary(d.dispute_data.dispute[0].summery);
        setcomplainantData(d.dispute_data.claimant);
        if (d.dispute_data.respondent.length > 0)
          setCompanyData(d.dispute_data.respondent);
        else setCompanyData([]);
        let resArbitrator = [];
        let resLawyer = [];
        let resWitness = [];
        let professionals = d.dispute_data.professionals;
        professionals.forEach((item) => {
          if (
            item.profile.profile_type == "arbitrator" ||
            item.profile.profile_type == "arbitrator_rv" ||
            item.profile.profile_type == "mediator"
          ) {
            resArbitrator.push(item);
          } else if (
            item.profile.profile_type == "lawyer" ||
            item.profile.profile_type == "lawyer_rv"
          ) {
            resLawyer.push(item);
          } else if (
            item.profile.profile_type == "witness" ||
            item.profile.profile_type == "witness_rv"
          ) {
            resWitness.push(item);
          }
        });
        setgroData(resArbitrator);
        setLawyerData(resLawyer);
        setwitnessData(resWitness);
        setCasemanagerData(d.dispute_data.case_manager_rv);
        let resultProfiles = [];
        if (d.dispute_data.claimant.length > 0) {
          d.dispute_data.claimant.forEach((item) => {
            let r = item;
            r.profile.rv_profile = "Claimant";
            resultProfiles.push(r);
          });
        }
        if (d.dispute_data.respondent.length > 0) {
          d.dispute_data.respondent.forEach((item) => {
            let r = item;
            r.profile.rv_profile = "Respondent";
            resultProfiles.push(r);
          });
        }
        d.dispute_data.professionals.forEach((item) => {
          resultProfiles.push(item);
        });
        setAllProfiles(resultProfiles);
        let date;
        if (
          (isSebi || isMSME) &&
          d.dispute_data.dispute[0].flow_type === "arbitration"
        ) {
          date = new Date(
            d.dispute_data.dispute[0].converted_to_arbitration_at
          );
        } else {
          date = new Date(d.dispute_data.dispute[0].created);
        }
        setStartDate(date.toLocaleDateString("en-GB"));
        if (d.dispute_data.dispute[0].approved) {
          date = new Date(d.dispute_data.dispute[0].approved_date);
          setApprovedDate(date.toLocaleDateString("en-US"));
        }
        let assignedProfiles = [];
        assignedProfiles = assignedProfiles
          .concat(d.dispute_data.claimant)
          .concat(d.dispute_data.respondent)
          .concat(resArbitrator)
          .concat(resLawyer)
          .concat(d.dispute_data.case_manager_rv)
          .concat(resWitness);
        setallAssignedPrifiles(assignedProfiles);
        setLoading(false);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    };
  }

  const shareDecision = (id) => {
    return async () => {
      try {
        const response = await instance.put(
          "/tiacfinaldecession/" + id + "/?host=" + getRealhost(),
          { dispute_id: dispute.id },
          {
            headers: {
              Accept: "application/json",
              "Content-type": "application/json",
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
  };

  const [loadingRegisterApi, setLoadingRegisterApi] = useState(false);

  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [openRegister, setOpenRegister] = React.useState(false);
  const [openAwardFinal, setOpenAwardFinal] = useState(false);
  const openPopupAwardFinal = () => {
    setAwardError("");
    setFiles([]);
    setOpenAwardFinal(true);
    instance
      .get("/bac/cases/" + caseId + "/award-parties/")
      .then((res) => {
        setAwardParties(res?.data?.parties || []);
        const isMulti = res?.data?.multiple_parties || false;
        setIsMultiAwardParties(isMulti);
        setAwardInFavourOf(isMulti ? [] : "");
      })
      .catch((error) => {
        console.log(error);
        setAwardParties([]);
        setIsMultiAwardParties(false);
        setAwardInFavourOf("");
      });
  };
  const closeAwardFinal = () => {
    setOpenAwardFinal(false);
    setOpenUpload(false);
    setFiles([]);
    setAwardParties([]);
    setAwardInFavourOf("");
    setAwardValue("");
    setApplicableStampDuty("");
    setIsMultiAwardParties(false);
    setAwardError("");
    refresh();
  };
  const [openAwardPartial, setOpenAwardPartial] = useState(false);
  const openPopupAwardPartial = () => {
    setAwardError("");
    setFiles([]);
    setOpenAwardPartial(true);
  };
  const closeAwardPartial = () => {
    setOpenAwardPartial(false);
    setOpenUpload(false);
    setFiles([]);
    setAwardError("");
    refresh();
  };

  const [loadingfiles, setLoadingfiles] = useState(false);
  const [openUpload, setOpenUpload] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const addFile = (file) => {
    setFiles((prevFiles) => [...prevFiles, file]);
  };
  const deleteFile = (index) => {
    let localFiles = [...files];
    localFiles.splice(index, 1);
    setFiles(localFiles);
  };

  const renderFiles = (files, deleteFile) => {
    return files.length !== 0
      ? files.map((file, index) => {
        return (
          <Box key={index}>
            <Box textAlign="center" position="relative">
              <Box>
                <Typography
                  style={{ wordBreak: "break-all", paddingTop: "20px" }}
                  variant="subtitle2"
                >
                  {file.name}
                </Typography>
                <IconButton
                  aria-label="delete"
                  color="primary"
                  onClick={() => {
                    deleteFile(index);
                  }}
                >
                  <DeleteOutlineIcon style={{ color: theme.palette.primary.main }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        );
      })
      : null;
  };

  function uploadDispute(files, activeDispute, type) {
    return async () => {
      const data = new FormData();
      files.forEach((file) => {
        data.append(file.name, file);
      });
      try {
        const response = await instance.put(
          "/uploaddispute/" + activeDispute.id + "/?award_type=" + type,
          data,
          {
            headers: {
              "content-type": "multipart/form-data",
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
  }

  const uploadAward = async (type, extraFields = {}) => {
    const arbitratorProfile = groData?.find(item => item.profile.profile_type === "arbitrator_rv")?.profile;
    const arbitratorId = arbitratorProfile?.id;

    const data = new FormData();
    data.append("award_file", files[0]);
    data.append("award_type", type);
    if (arbitratorId) {
      data.append("arbitrator_id", arbitratorId);
    }
    Object.keys(extraFields).forEach((key) => {
      if (extraFields[key] !== undefined && extraFields[key] !== null) {
        if (key === "award_in_favour_of" && Array.isArray(extraFields[key])) {
          extraFields[key].forEach((val) => {
            data.append("award_in_favour_of", val);
          });
        } else {
          data.append(key, extraFields[key]);
        }
      }
    });

    await instance.post(
      "/bac/arbitrator/cases/" + dispute.id + "/award/",
      data,
      { headers: { "content-type": "multipart/form-data" } }
    );
  };

  const uploadDecision = (type) => {
    setAwardError("");
    if (type === "final_award") {
      const favorOf = Array.isArray(awardInFavourOf)
        ? awardInFavourOf
        : (awardInFavourOf ? [awardInFavourOf] : []);
      if (favorOf.length === 0 || (favorOf.length === 1 && !favorOf[0]?.trim())) {
        setAwardError("Please select whom the Award is in Favour of.");
        return;
      }
      if (awardValue === undefined || awardValue === null || awardValue === "") {
        setAwardError("Please enter the Award Value.");
        return;
      }
      if (applicableStampDuty === undefined || applicableStampDuty === null || applicableStampDuty === "") {
        setAwardError("Please enter the Applicable Stamp Duty.");
        return;
      }
    }

    setLoadingfiles(true);
    const favorOf = Array.isArray(awardInFavourOf)
      ? awardInFavourOf
      : (awardInFavourOf ? [awardInFavourOf] : []);
    const extraFields =
      type === "final_award"
        ? {
          award_in_favour_of: favorOf,
          award_value: awardValue,
          applicable_stamp_duty: applicableStampDuty,
          docs_arb_final_order_folder_id: dispute.docs_arb_final_order_folder_id,
        }
        : {
          docs_arb_interim_order_folder_id:
            dispute.docs_arb_interim_order_folder_id,
        };

    uploadAward(type, extraFields)
      .then(() => {
        setLoadingfiles(false);
        setFiles([]);
        if (type == "final_award") {
          closeAwardFinal();
        } else {
          closeAwardPartial();
        }
      })
      .catch((error) => {
        console.error(error);
        setLoadingfiles(false);
        setAwardError(
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          "The award could not be uploaded. Please try again."
        );
      });
  };

  const renderAwardUpload = (type) => {
    if (isDisputeClosed) return null;
    const isFinalAward = type === "final_award";
    const submitDisabled = files.length < 1 || loadingfiles;
    return (
      <>
        {files.length === 0 && (
          <Box
            className={classes.awardDropzone}
            onClick={() => {
              setOpenUpload(true);
            }}
          >
            <AddCircleOutlineIcon color="primary" />
            <Typography className={classes.awardDropzoneText}>
              Add {isFinalAward ? "final" : "interim"} award document
            </Typography>
          </Box>
        )}
        {renderFiles(files, deleteFile)}
        {isFinalAward && files.length > 0 && (
          <Box
            width="100%"
            maxWidth="400px"
            style={{ margin: "1rem auto", textAlign: "left" }}
          >
            <Typography
              style={{
                fontSize: "16px",
                color: TEXT.primary,
                fontWeight: "bold",
                marginBottom: "0.5rem",
              }}
            >
              Final Award Details
            </Typography>

            {awardParties.length > 0 ? (
              <FormControl
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
              >
                <InputLabel>Award in Favour of</InputLabel>
                <Select
                  label="Award in Favour of"
                  multiple={isMultiAwardParties}
                  value={
                    isMultiAwardParties
                      ? Array.isArray(awardInFavourOf)
                        ? awardInFavourOf
                        : []
                      : Array.isArray(awardInFavourOf)
                        ? ""
                        : awardInFavourOf
                  }
                  onChange={(e) => setAwardInFavourOf(e.target.value)}
                  renderValue={(selected) => {
                    if (isMultiAwardParties && Array.isArray(selected)) {
                      return (
                        <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                          {selected.map((val) => {
                            const p = awardParties.find(
                              (party) => party.value === val
                            );
                            return (
                              <Chip
                                key={val}
                                label={p ? p.label : val}
                                size="small"
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                }}
                                onDelete={() => {
                                  const newValue = selected.filter(
                                    (v) => v !== val
                                  );
                                  setAwardInFavourOf(newValue);
                                }}
                              />
                            );
                          })}
                        </Box>
                      );
                    }
                    const p = awardParties.find(
                      (party) => party.value === selected
                    );
                    return p ? p.label : selected;
                  }}
                >
                  {awardParties.map((party, index) => (
                    <MenuItem key={index} value={party.value}>
                      {isMultiAwardParties && (
                        <Checkbox
                          checked={
                            Array.isArray(awardInFavourOf) &&
                            awardInFavourOf.indexOf(party.value) > -1
                          }
                          size="small"
                          color="primary"
                          style={{ padding: "0 8px 0 0" }}
                        />
                      )}
                      {party.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                required
                fullWidth
                size="small"
                margin="dense"
                variant="outlined"
                label="Award in Favour of"
                value={awardInFavourOf}
                onChange={(e) => setAwardInFavourOf(e.target.value)}
              />
            )}

            <TextField
              required
              fullWidth
              size="small"
              margin="dense"
              variant="outlined"
              label="Award Value (INR)"
              type="number"
              value={awardValue}
              onChange={(e) => {
                if (isAllowedAmountInput(e.target.value)) setAwardValue(e.target.value);
              }}
            />

            <TextField
              required
              fullWidth
              size="small"
              margin="dense"
              variant="outlined"
              label="Applicable Stamp Duty (INR)"
              type="number"
              value={applicableStampDuty}
              onChange={(e) => {
                if (isAllowedAmountInput(e.target.value)) setApplicableStampDuty(e.target.value);
              }}
            />
          </Box>
        )}
        <Box width="100%" maxWidth="400px" style={{ margin: "0 auto" }}>
          <FormError
            message={awardError}
            style={{ marginTop: 0, marginBottom: "0.75rem" }}
          />
        </Box>
        <Button
          variant="contained"
          style={{
            width: "224px",
            marginTop: "1.25rem",
            textTransform: "none",
            boxShadow: "none",
            background: submitDisabled
              ? "rgba(0,0,0,0.12)"
              : theme.palette.primary.main,
          }}
          onClick={() => {
            uploadDecision(type);
          }}
          disabled={submitDisabled}
        >
          <Typography
            style={{ color: submitDisabled ? "rgba(0,0,0,0.26)" : "#fff" }}
          >
            {loadingfiles ? "SUBMITTING..." : "SUBMIT"}
          </Typography>
        </Button>
      </>
    );
  };

  const renderAwardsTable = (type, closeModal) => {
    const awards = decisions.filter(
      (item) => !item.is_rfa_rv && item.award_type == type
    );
    return (
      <TableContainer className={classes.awardTableWrap}>
        <Table>
          <colgroup>
            <col style={{ width: "55%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell>Document Name</TableCell>
              <TableCell>Upload Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {awards.length === 0 ? (
              <TableRow>
                <TableCell
                  className={classes.awardEmptyCell}
                  colSpan={4}
                  align="center"
                >
                  No documents uploaded yet.
                </TableCell>
              </TableRow>
            ) : (
              awards.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Typography
                      className={classes.awardDocName}
                      onClick={() => {
                        downloadLegalDoc(item.id);
                      }}
                    >
                      {breakableFileName(item.name)}
                    </Typography>
                  </TableCell>
                  <TableCell>{safeDateFormat(item.created)}</TableCell>
                  <TableCell>
                    {item.is_final ? (
                      <Chip
                        size="small"
                        label="Shared"
                        className={classes.awardSharedChip}
                      />
                    ) : (
                      <Button
                        color="primary"
                        className={classes.awardShareBtn}
                        disabled={isDisputeClosed}
                        onClick={async () => {
                          await dispatch(shareDecision(item.id));
                          closeModal();
                        }}
                      >
                        Share
                      </Button>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      aria-label="delete document"
                      disabled={isDisputeClosed}
                      onClick={async () => {
                        await deleteDecisionId(item.id);
                        closeModal();
                      }}
                    >
                      <DeleteOutlineIcon
                        fontSize="small"
                        style={{
                          color: isDisputeClosed ? undefined : "#C62828",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const [openRFA, setOpenRFA] = useState(false);

  const openPopupRFA = () => setOpenRFA(true);
  const closeRFA = () => {
    setOpenRFA(false);
    refresh();
  };

  const openpopup2 = () => {
    setSelectedClosureReason("");
    setClosureReasonError("");
    setDisposalDate(null);
    setDisposalDateError("");
    fetchClosureReasons();
    setOpen2(true);
  };

  const openpopup3 = () => {
    setOpen3(true);
  };

  const openpopupRegister = () => {
    setOpenRegister(true);
  };

  const closeModal2 = () => {
    setOpen2(false);
  };

  const closeModal3 = () => {
    setOpen3(false);
  };

  const closeModalRegister = () => {
    setOpenRegister(false);
    setRegisterError("");
  };

  const handleMoveToArbitration = async () => {
    try {
      setLoading(true);
      const response = await instance.post(
        `/sebi/convert_to_arbitration/${dispute.id}/`
      );
      setLoading(false);
      showSnackbar("Moved to Arbitration", "success");
      refresh();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const ApproveDispute = () => {
    if (!loadingRegisterApi) {
      setRegisterError("");
      if (dispute.rv_tiac_payment_status == "complete") {
        setLoadingRegisterApi(true);
        dispatch(
          approvedDispute({
            id: caseId,
          })
        ).then(() => {
          closeModalRegister();
          refresh();
          reloadOverview();
          setLoadingRegisterApi(false);
        });
      } else {
        setRegisterError(
          "Please confirm that the Claimant has paid the registration fees before registering the arbitration."
        );
      }
    }
  };

  const closeGrievence = async () => {
    if (loadingCaseClose) return; // Prevent multiple clicks

    const formattedDisposalDate = formatApiDate(disposalDate);
    const dateError = formattedDisposalDate ? "" : "Date of disposal is required";
    const reasonError = selectedClosureReason ? "" : "Nature of disposal is required";
    setDisposalDateError(dateError);
    setClosureReasonError(reasonError);
    if (dateError || reasonError) return;

    try {
      setLoadingCaseClose(true);
      await dispatch(
        CloseDisputeAtLevelTwo(caseId, selectedClosureReason, {}, {
          dateclosed_level2: formattedDisposalDate,
        })
      );

      // Reload overview and update state
      reloadOverview();
      setIsDisputeClosed(true);
      // Refetch so the mandate clock switches to its closed view and shows
      // the nature of disposal.
      refresh();
      setOpen2(false);
    } catch (error) {
      console.error("Error in closing grievance:", error);
    } finally {
      setLoadingCaseClose(false);
    }
  };

  const openReopenPopup = () => {
    setReopenError("");
    setReopenReason("");
    setReopenReasonError("");
    setOpenReopen(true);
  };

  const closeReopenPopup = () => {
    if (loadingReopen) return;
    setOpenReopen(false);
  };

  const handleReopenCase = async () => {
    if (loadingReopen) return;
    const reason = reopenReason.trim();
    if (!reason) {
      setReopenReasonError("Reason for reopening is required");
      return;
    }
    try {
      setLoadingReopen(true);
      setReopenError("");
      await reopenDispute(dispute.id, dispute.name, dispute.description, reason);
      showSnackbar("Case reopened", "success");
      setOpenReopen(false);
      setIsDisputeClosed(false);
      reloadOverview();
      // Refetch so the mandate clock and closure reason reflect the reopened case.
      refresh();
    } catch (error) {
      console.error("Error in reopening case:", error);
      setReopenError(
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "The case could not be reopened. Please try again."
      );
    } finally {
      setLoadingReopen(false);
    }
  };


  async function deleteDecisionId(id) {
    return await instance.delete(`/arbitrator_decisiondelete/${id}/`);
  }

  function completepayment(disputeId) {
    return async () => {
      try {
        let response = await instance({
          method: "get",
          url: `/completepayment/${disputeId}/`,
        });
        return response.data;
      } catch (error) {
        console.log("error.request.status", error.request.status);
        console.log("error.message", error.message);
      }
    };
  }
  const handlePayment = () => {
    dispatch(completepayment(dispute.id)).then(() => {
      refresh();
    });
  };

  if (loading) {
    return <CircularCenteredLoader />;
  } else {
    return (
      <Grid
        ref={topRef}
        container
        justify="flex-start"
        direction="column"
        style={{ padding: "1rem" }}
      >
        <Grid item>
          <Grid container justify="space-between">
            <Grid item>
              <Button
                onClick={() => {
                  setOpenCase(false);
                  sessionStorage.removeItem("bac_overview_caseid");
                }}
                className={classes.backbtn}
                startIcon={<ArrowBackIosIcon />}
              >
                Back to all cases
              </Button>
            </Grid>
          </Grid>
          <Box height="2rem"></Box>
          {/* {!isSmallScreen() ? ( */}
          <>
            <Grid
              container
              direction="row"
              alignItems="stretch"
              style={{ display: "flex" }}
              spacing={2}
            >
              <Grid item sm={10} xs={12} style={{ flex: "1" }}>
                <Paper
                  style={{
                    height: "100%",
                    background: "none",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <Grid container justify="space-between">
                    <Grid item>
                      <Box display="flex" alignItems="center" style={{ gap: "0.75rem" }}>
                        <Typography component="h1" className={classes.blackheading}>
                          Case ID:{" "}
                          {dispute.tiac_custom_dispute_id}
                        </Typography>
                        {isCaseReopened(dispute) && (
                          <ReopenedChip
                            reopenDate={dispute.reopen_date}
                            reopenReason={dispute.reopen_reason}
                          />
                        )}
                      </Box>
                    </Grid>
                    <Grid item style={{ textAlign: "right" }}>
                      <Typography className={classes.blackheading}>
                        Start Date: {startDate}
                      </Typography>
                      {/* {isCaseReopened(dispute) && dispute.reopen_date && (
                        <Typography className={classes.reopenedOn}>
                          Reopened On: {safeDateFormat(dispute.reopen_date)}
                        </Typography>
                      )} */}
                    </Grid>
                    {/* <Grid item>
                      <Typography className={classes.blackheading}>
                        Registration Date: {approvedDate}
                      </Typography>
                    </Grid> */}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              justify="space-evenly"
              direction="row"
              alignItems="stretch"
              // style={{ display: "flex" }}
              spacing={3}
            >
              {dispute?.mandate && (
                <Grid item md={12} sm={12} xs={12}>
                  <Box mb={2}>
                    <MandateClock
                      mandate={dispute.mandate}
                      closureReason={dispute?.reason_for_closure}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item md={12} sm={12} xs={12}>
                <Summary summary={summary} caseId={caseId} isDisputeClosed={isDisputeClosed} />
              </Grid>
            </Grid>
          </>
          <Box height="2rem"></Box>
          <Grid container justify="flex-start" spacing={2} wrap="wrap">
            {complainantData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Complainant
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  lawyerDataRV={lawyerDataRV}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  casefiles={casefiles}
                  updateDisputeName={updateDisputeName}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {complainantData.map((complainant, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <Complainant
                    isSmallScreen={isSmallScreen}
                    groData={complainant}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    lawyerDataRV={lawyerDataRV}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    updateDisputeName={updateDisputeName}
                    casefiles={casefiles}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}
            {companyData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Company
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  lawyerDataRV={lawyerDataRV}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  updateDisputeName={updateDisputeName}
                  casefiles={casefiles}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {companyData.map((respondent, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <Company
                    isSmallScreen={isSmallScreen}
                    groData={respondent}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    lawyerDataRV={lawyerDataRV}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    updateDisputeName={updateDisputeName}
                    casefiles={casefiles}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}

            {groData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <GRO
                  isSmallScreen={isSmallScreen}
                  groData={null}
                  preGroData={groData}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  group={profile.group}
                  profileType={"arbitrator_rv"}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {groData.map((item, index) => {
              return (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                  key={index}
                >
                  <GRO
                    isSmallScreen={isSmallScreen}
                    groData={item}
                    preGroData={groData}
                    caseId={caseId}
                    mode={mode}
                    index={index}
                    refresh={refresh}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    group={profile.group}
                    profileType={"arbitrator_rv"}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              );
            })}
            {ClaimantLawyerData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <SRB
                  isSmallScreen={isSmallScreen}
                  caseId={caseId}
                  groData={null}
                  mode={mode}
                  lawyerDataRV={lawyerDataRV}
                  casefile={casefiles}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  prevLaw={[]}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {ClaimantLawyerData.map((clitem, index) => {
              if (
                lawyerData.find(
                  (element) => element.profile.id == clitem.lawyer
                )
              ) {
                let item =
                  lawyerData[
                  lawyerData.findIndex(
                    (element) => element.profile.id == clitem.lawyer
                  )
                  ];
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={item.profile.id}
                  >
                    <SRB
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={item}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={clitem.all}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              } else {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={"empty" + index}
                  >
                    <SRB
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={null}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={[]}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              }
            })}
            {RespondentLawyerData.length == 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <RespondentLawyer
                  isSmallScreen={isSmallScreen}
                  caseId={caseId}
                  groData={null}
                  mode={mode}
                  lawyerDataRV={lawyerDataRV}
                  casefile={casefiles}
                  index={null}
                  refresh={refresh}
                  allAssignedPrifiles={allAssignedPrifiles}
                  dispute={dispute}
                  prevLaw={[]}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {RespondentLawyerData.map((clitem, index) => {
              if (
                lawyerData.find(
                  (element) => element.profile.id == clitem.lawyer
                )
              ) {
                let item =
                  lawyerData[
                  lawyerData.findIndex(
                    (element) => element.profile.id == clitem.lawyer
                  )
                  ];
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={item.profile.id}
                  >
                    <RespondentLawyer
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={item}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={clitem.all}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              } else {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={"empty" + index}
                  >
                    <RespondentLawyer
                      isSmallScreen={isSmallScreen}
                      caseId={caseId}
                      groData={null}
                      mode={mode}
                      lawyerDataRV={lawyerDataRV}
                      casefile={clitem.casefile}
                      index={clitem.index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      prevLaw={[]}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              }
            })}

            {/* {(isSebi || isMSME) && witnessData.length === 0 && (
              <Grid
                item
                sm={6}
                md={6}
                lg={4}
                style={{ width: "100%", display: "flex" }}
              >
                <Witness
                  groData={null}
                  caseId={caseId}
                  mode={mode}
                  index={null}
                  refresh={refresh}
                  dispute={dispute}
                  allAssignedPrifiles={allAssignedPrifiles}
                  casefiles={casefiles}
                  group={profile.group}
                  isDisputeClosed={isDisputeClosed}
                />
              </Grid>
            )}
            {(isSebi || isMSME) &&
              witnessData.map((item, index) => {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                  >
                    <Witness
                      groData={item}
                      caseId={caseId}
                      mode={mode}
                      index={index}
                      refresh={refresh}
                      dispute={dispute}
                      allAssignedPrifiles={allAssignedPrifiles}
                      casefiles={casefiles}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              })} */}

            {/* {casemanagerData.length == 0 &&
              profile.profile_type == "sub_admin_tiac_rv" && (
                <Grid
                  item
                  sm={6}
                  md={6}
                  lg={4}
                  style={{ width: "100%", display: "flex" }}
                >
                  <CaseManager
                    isSmallScreen={isSmallScreen}
                    groData={null}
                    preGroData={groData}
                    caseId={caseId}
                    mode={mode}
                    index={null}
                    refresh={refresh}
                    allAssignedPrifiles={allAssignedPrifiles}
                    dispute={dispute}
                    group={profile.group}
                    isDisputeClosed={isDisputeClosed}
                  />
                </Grid>
              )}
            {profile.profile_type == "sub_admin_tiac_rv" &&
              casemanagerData.map((item, index) => {
                return (
                  <Grid
                    item
                    sm={6}
                    md={6}
                    lg={4}
                    style={{ width: "100%", display: "flex" }}
                    key={index}
                  >
                    <CaseManager
                      isSmallScreen={isSmallScreen}
                      groData={item}
                      preGroData={groData}
                      caseId={caseId}
                      mode={mode}
                      index={index}
                      refresh={refresh}
                      allAssignedPrifiles={allAssignedPrifiles}
                      dispute={dispute}
                      group={profile.group}
                      isDisputeClosed={isDisputeClosed}
                    />
                  </Grid>
                );
              })} */}
          </Grid>
          <Box height="4rem"></Box>
          <Grid container spacing={2}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.bigbtn}
                size="large"
                style={{ width: "100%" }}
                onClick={() => {
                  history.push(`/disputes/${caseId}/files/0`);
                }}
              >
                Files
              </Button>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.bigbtn}
                size="large"
                style={{ width: "100%" }}
                onClick={() => {
                  openPopupAwardPartial();
                }}
              >
                Interim Award
              </Button>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.bigbtn}
                size="large"
                style={{ width: "100%" }}
                onClick={() => {
                  openPopupAwardFinal();
                }}
              >
                Final Award
              </Button>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.bigbtn}
                size="large"
                style={{ width: "100%" }}
                onClick={() => {
                  if (isDisputeClosed) {
                    openReopenPopup();
                  } else {
                    openpopup2();
                  }
                }}
              >
                {isDisputeClosed ? "Reopen Case" : "Disposal"}
              </Button>
            </Grid>
            {can("order_drafting") && (
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.bigbtn}
                  size="large"
                  style={{ width: "100%" }}
                  onClick={openOrderDrafting}
                >
                  Order Drafting
                </Button>
              </Grid>
            )}
          </Grid>
          <Box height="5rem"></Box>
          {/* <Grid container justify="flex-start">
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>NAME</Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>
                PROFILE TYPE
              </Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>CALENDAR</Typography>
            </Grid>
            <Grid item sm={3} xs={3}>
              <Typography className={classes.blueheading}>DRIVE</Typography>
            </Grid>
          </Grid>
          <Box height="0.4rem"></Box>
          {allProfiles.map((profile) => {
            return (
              <CaseDisplayProfileList
                key={profile.profile.id}
                profile={profile}
                caseId={caseId}
                mode={mode}
              />
            );
          })} */}
        </Grid>

        {/* <Box height="2rem" /> */}
        <Grid container>
          <Grid item xs={12}>
            <GeneralActivitiesACCB
              activities={activities}
              setActivities={setActivities}
              isGetActivityByTabAndId={true}
              disputeId={caseId}
              activityTitle="Case Activity"
            />
            <Box height="2rem" />
          </Grid>
        </Grid>

        <Popup
          open={openRegister}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeModalRegister}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "330px",
            height: "185px",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Typography
              style={{
                fontSize: "20px",
                color: TEXT.primary,
                "font-weight": "bold",
                "line-height": "23px",
                "letter-spacing": "0.0015em",
              }}
            >
              Are you sure?
            </Typography>
            <Box height="0.5rem"></Box>
            <Typography
              style={{
                fontSize: "16px",
                color: TEXT.muted,
                "line-height": "28px",
              }}
            >
              Are you sure you want to register this case?
            </Typography>
            <Box height="0.7rem"></Box>
          </Box>
          <Box style={{ padding: "1rem 1.3rem" }}>
            <FormError message={registerError} style={{ marginTop: 0, marginBottom: "0.75rem" }} />
            <Grid container direction="row" justify="flex-end" spacing={2}>
              <Grid item>
                <Typography
                  style={{
                    fontSize: "14px",
                    color: TEXT.muted,
                    "line-height": "16px",
                    "letter-spacing": "0.02em",
                    "font-weight": "500",
                    cursor: "pointer",
                  }}
                  onClick={closeModalRegister}
                >
                  CANCEL
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  style={
                    loadingRegisterApi
                      ? {
                        fontSize: "14px",
                        color: theme.palette.primary.main,
                        "line-height": "16px",
                        "letter-spacing": "0.02em",
                        "font-weight": "500",
                        cursor: "wait",
                      }
                      : {
                        fontSize: "14px",
                        color: theme.palette.primary.main,
                        "line-height": "16px",
                        "letter-spacing": "0.02em",
                        "font-weight": "500",
                        cursor: "pointer",
                      }
                  }
                  onClick={ApproveDispute}
                >
                  REGISTER
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Popup>
        <Popup
          open={open2}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeModal2}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "440px",
            maxWidth: "92vw",
            height: "auto",
            padding: 0,
            border: "none",
            borderRadius: "4px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box className={classes.closeCaseHeader}>
            <Box className={classes.closeCaseIcon}>
              <ReportProblemOutlinedIcon />
            </Box>
            <Box>
              <Typography className={classes.closeCaseTitle}>
                Proceed with Disposal?
              </Typography>
              <Typography className={classes.closeCaseSubtitle}>
                {dispute.tiac_custom_dispute_id ? (
                  <>
                    Case <strong>{dispute.tiac_custom_dispute_id}</strong> will
                    be moved to Disposal.
                  </>
                ) : (
                  "This case will be moved to Disposal."
                )}{" "}
                Enter the date and nature of disposal to continue.
              </Typography>
            </Box>
            <IconButton
              aria-label="Cancel"
              className={classes.closeCaseDismiss}
              onClick={closeModal2}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box className={classes.closeCaseBody}>
            <DatePickerACCB
              label="Date of Disposal"
              value={disposalDate}
              onChange={(newDate) => {
                setDisposalDate(newDate);
                setDisposalDateError("");
              }}
              required
              maxDate={new Date()}
              error={!!disposalDateError}
              helperText={disposalDateError || " "}
            />
            <Box height="0.5rem" />
            <FormControl
              fullWidth
              required
              size="small"
              variant="outlined"
              error={!!closureReasonError}
            >
              <InputLabel id="closure-reason-label">Nature of Disposal</InputLabel>
              <Select
                labelId="closure-reason-label"
                id="closure-reason-select"
                value={selectedClosureReason}
                onChange={(e) => {
                  setSelectedClosureReason(e.target.value);
                  setClosureReasonError("");
                }}
                label="Nature of Disposal *"
                style={{ textAlign: "left" }}
                disabled={closureReasonsLoading}
                endAdornment={
                  closureReasonsLoading ? (
                    <CircularProgress size={18} style={{ marginRight: "2rem" }} />
                  ) : null
                }
                // Open the list below the field instead of over it, so the
                // label and current value stay visible while choosing.
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: "bottom", horizontal: "left" },
                  transformOrigin: { vertical: "top", horizontal: "left" },
                }}
              >
                {closureReasons.length === 0 ? (
                  <MenuItem disabled value="" className={classes.closeCaseEmpty}>
                    No nature of disposal options are configured.
                  </MenuItem>
                ) : (
                  closureReasons.map((item) => (
                    <MenuItem key={item.id} value={item.reason}>
                      {item.reason}
                    </MenuItem>
                  ))
                )}
              </Select>
              <FormHelperText>
                {closureReasonError ||
                  (!closureReasonsLoading && closureReasons.length === 0
                    ? "No nature of disposal options are available. Please contact support."
                    : "")}
              </FormHelperText>
            </FormControl>
          </Box>
          <Box className={classes.closeCaseActions}>
            <Button
              variant="outlined"
              color="primary"
              onClick={closeModal2}
              disabled={loadingCaseClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.closeCaseConfirm}
              onClick={closeGrievence}
              disabled={
                loadingCaseClose ||
                closureReasonsLoading ||
                closureReasons.length === 0
              }
            >
              {loadingCaseClose ? (
                <CircularProgress size={20} style={{ color: "inherit" }} />
              ) : (
                "Disposal"
              )}
            </Button>
          </Box>
        </Popup>
        <Popup
          open={openReopen}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeReopenPopup}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "440px",
            maxWidth: "92vw",
            height: "auto",
            padding: 0,
            border: "none",
            borderRadius: "8px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.18)",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box className={classes.closeCaseHeader}>
            <Box>
              <Typography className={classes.closeCaseTitle}>
                Reopen this case?
              </Typography>
              <Typography className={classes.closeCaseSubtitle}>
                {dispute?.tiac_custom_dispute_id ? (
                  <>
                    Case <strong>{dispute.tiac_custom_dispute_id}</strong> will
                    be reopened
                  </>
                ) : (
                  "This case will be reopened"
                )}
                {dispute?.reason_for_closure && (
                  <>
                    {" "}(Nature of Disposal: <strong>{dispute.reason_for_closure}</strong>)
                  </>
                )}
                . Parties and the tribunal will be able to act on it again.
                Enter the reason for reopening to continue.
              </Typography>
            </Box>
            <IconButton
              aria-label="Cancel"
              className={classes.closeCaseDismiss}
              onClick={closeReopenPopup}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box className={classes.closeCaseBody}>
            <TextField
              label="Reason for Reopening"
              required
              fullWidth
              multiline
              rows={3}
              rowsMax={10}
              variant="outlined"
              value={reopenReason}
              onChange={(e) => {
                setReopenReason(
                  e.target.value.slice(0, REOPEN_REASON_MAX_LENGTH)
                );
                setReopenReasonError("");
              }}
              inputProps={{ maxLength: REOPEN_REASON_MAX_LENGTH }}
              disabled={loadingReopen}
              error={!!reopenReasonError}
              // The error (if any) on the left, the character count on the right.
              helperText={
                <Box component="span" display="flex" justifyContent="space-between">
                  <span>{reopenReasonError}</span>
                  <span>
                    {reopenReason.length}/{REOPEN_REASON_MAX_LENGTH}
                  </span>
                </Box>
              }
            />
            {reopenError && (
              <FormHelperText error>{reopenError}</FormHelperText>
            )}
          </Box>
          <Box className={classes.closeCaseActions}>
            <Button
              variant="outlined"
              color="primary"
              onClick={closeReopenPopup}
              disabled={loadingReopen}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.closeCaseConfirm}
              onClick={handleReopenCase}
              disabled={loadingReopen}
            >
              {loadingReopen ? (
                <CircularProgress size={20} style={{ color: "inherit" }} />
              ) : (
                "Reopen Case"
              )}
            </Button>
          </Box>
        </Popup>
        <Popup
          open={open3}
          closeOnDocumentClick
          closeOnEscape
          onClose={closeModal3}
          position="center"
          modal
          nested
          contentStyle={{
            background: "white",
            width: "400px",
            // height: "170px",
            textAlign: "left",
          }}
          overlayStyle={{ background: "rgba(51, 51, 51, 0.7)" }}
        >
          <Box style={{ padding: "1rem 1.3rem" }}>
            <Typography
              style={{
                fontSize: "16px",
                color: TEXT.muted,
                "line-height": "28px",
                textAlign: "left",
                paddingTop: " 1.3rem",
              }}
            >
              Claimant Status :
              <br />
              {dispute.rv_arbitrator_step_complete
                ? "Mediator choose step : Complete"
                : "Mediator choose step : Incomplete"}
              <br />
              {dispute.rv_claimant_lawyer_step_complete
                ? "Counsel choose step : Complete"
                : "Counsel choose step : Incomplete"}
              <br />
              {dispute.rv_respondent_choose_step_complete
                ? "Respondent choose step : Complete"
                : "Respondent choose step : Incomplete"}
              <br />
            </Typography>
            <Typography
              style={{
                fontSize: "16px",
                color: TEXT.muted,
                "line-height": "28px",
                textAlign: "left",
                paddingTop: " 1.3rem",
              }}
            >
              Respondent Status :
              <br />
              {dispute.rv_respondent_lawyer_step_complete
                ? "Counsel choose step : Complete"
                : "Counsel choose step : Incomplete"}
            </Typography>
          </Box>
        </Popup>
        <Modal
          open={openAwardFinal}
          onClose={closeAwardFinal}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openAwardFinal}>
            <Paper className={classes.awardModalPaper}>
              <CloseModalButton onClick={closeAwardFinal} />
              <Typography className={classes.awardModalTitle}>
                Final Awards
              </Typography>
              {renderAwardsTable("final_award", closeAwardFinal)}
              {renderAwardUpload("final_award")}
            </Paper>
          </Fade>
        </Modal>
        <Modal
          open={openAwardPartial}
          onClose={closeAwardPartial}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openAwardPartial}>
            <Paper className={classes.awardModalPaper}>
              <CloseModalButton onClick={closeAwardPartial} />
              <Typography className={classes.awardModalTitle}>
                Interim Awards
              </Typography>
              {renderAwardsTable("partial_award", closeAwardPartial)}
              {renderAwardUpload("partial_award")}
            </Paper>
          </Fade>
        </Modal>
        <Modal
          open={openRFA}
          onClose={closeRFA}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          disableEnforceFocus
        >
          <Fade in={openRFA}>
            <Paper className={classes.awardpaper}>
              <CloseModalButton onClick={closeRFA} />
              <Typography
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                MRF
              </Typography>
              <Box height="1rem" />
              {commonFiles.map((item) => {
                if (item.is_rfa_rv && item.award_type == "partial_award")
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {"Arbitration agreement" + "_" + item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                else if (item.is_rfa_rv && item.award_type == "final_award")
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {"Contract" + "_" + item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                else if (item.is_rfa_rv)
                  return (
                    <React.Fragment key={item.id}>
                      <Grid container>
                        <Grid item xs={12}>
                          <MenuItem
                            onClick={() => {
                              downloadLegalDoc(item.id);
                            }}
                          >
                            {item.name}
                          </MenuItem>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
              })}
            </Paper>
          </Fade>
        </Modal>
        <DropzoneDialog
          cancelButtonText={"cancel"}
          submitButtonText={"submit"}
          maxFileSize={104857600}
          open={openUpload}
          onClose={() => setOpenUpload(false)}
          onSave={(uploadedFiles) => {
            uploadedFiles.forEach((file) => {
              addFile(file);
            });
            setOpenUpload(false);
          }}
          showPreviews={true}
          filesLimit={1}
          showFileNamesInPreview={true}
          previewGridProps={{
            container: { spacing: 1 },
            item: { xs: 12 },
          }}
          previewGridClasses={{ item: classes.dropzonePreviewItem }}
          acceptedFiles={[
            "image/jpeg",
            "image/png",
            "image/jpg",
            "application/msword",
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ]}
        />
      </Grid>
    );
  }
}
